// Destination to language mapping
export const DESTINATION_LANGUAGE_MAP = {
  'spain': 'spanish', 'mexico': 'spanish', 'colombia': 'spanish', 'argentina': 'spanish',
  'peru': 'spanish', 'chile': 'spanish', 'ecuador': 'spanish', 'bolivia': 'spanish',
  'costa rica': 'spanish', 'cuba': 'spanish', 'dominican republic': 'spanish',
  'guatemala': 'spanish', 'honduras': 'spanish', 'nicaragua': 'spanish', 'panama': 'spanish',
  'france': 'french', 'paris': 'french', 'morocco': 'french', 'belgium': 'french',
  'switzerland': 'french', 'senegal': 'french', 'tunisia': 'french',
  'portugal': 'portuguese', 'brazil': 'portuguese', 'lisbon': 'portuguese',
  'germany': 'german', 'austria': 'german', 'berlin': 'german', 'munich': 'german',
  'italy': 'italian', 'rome': 'italian', 'milan': 'italian', 'florence': 'italian',
  'thailand': 'thai', 'bangkok': 'thai', 'chiang mai': 'thai', 'phuket': 'thai',
  'vietnam': 'vietnamese', 'hanoi': 'vietnamese', 'ho chi minh': 'vietnamese',
  'japan': 'japanese', 'tokyo': 'japanese', 'osaka': 'japanese', 'kyoto': 'japanese',
  'egypt': 'arabic', 'dubai': 'arabic', 'jordan': 'arabic', 'saudi arabia': 'arabic',
  'morocco': 'arabic', 'lebanon': 'arabic', 'uae': 'arabic', 'qatar': 'arabic',
  'china': 'mandarin', 'beijing': 'mandarin', 'shanghai': 'mandarin', 'taiwan': 'mandarin',
  'hong kong': 'mandarin', 'singapore': 'mandarin',
};

export const LANGUAGES = {
  spanish: { name: 'Spanish', native: 'Español', flag: '🇪🇸' },
  french: { name: 'French', native: 'Français', flag: '🇫🇷' },
  portuguese: { name: 'Portuguese', native: 'Português', flag: '🇧🇷' },
  german: { name: 'German', native: 'Deutsch', flag: '🇩🇪' },
  italian: { name: 'Italian', native: 'Italiano', flag: '🇮🇹' },
  thai: { name: 'Thai', native: 'ภาษาไทย', flag: '🇹🇭' },
  vietnamese: { name: 'Vietnamese', native: 'Tiếng Việt', flag: '🇻🇳' },
  japanese: { name: 'Japanese', native: '日本語', flag: '🇯🇵' },
  arabic: { name: 'Arabic', native: 'العربية', flag: '🇸🇦' },
  mandarin: { name: 'Mandarin', native: '中文', flag: '🇨🇳' },
};

export const CATEGORIES = [
  { id: 'emergency', name: 'Emergency', icon: 'warning' },
  { id: 'greetings', name: 'Greetings', icon: 'hand-waving' },
  { id: 'basics', name: 'Basics', icon: 'chat-text' },
  { id: 'transportation', name: 'Transportation', icon: 'car' },
  { id: 'hotel', name: 'Hotel & Lodging', icon: 'bed' },
  { id: 'food', name: 'Food & Drink', icon: 'fork-knife' },
  { id: 'bathroom', name: 'Bathroom', icon: 'toilet' },
  { id: 'shopping', name: 'Shopping & Money', icon: 'shopping-cart' },
  { id: 'health', name: 'Health & Pharmacy', icon: 'first-aid-kit' },
  { id: 'police', name: 'Police & Safety', icon: 'shield-check' },
  { id: 'airport', name: 'Airport & Border', icon: 'airplane' },
  { id: 'phone', name: 'Phone & Internet', icon: 'wifi-high' },
  { id: 'nightlife', name: 'Nightlife & Social', icon: 'beer-bottle' },
  { id: 'fitness', name: 'Fitness & Gym', icon: 'barbell' },
  { id: 'respectful', name: 'Respectful Phrases', icon: 'heart' },
];

export function detectLanguageFromDestination(destination) {
  if (!destination) return null;
  const lower = destination.toLowerCase().trim();
  for (const [key, lang] of Object.entries(DESTINATION_LANGUAGE_MAP)) {
    if (lower.includes(key)) return lang;
  }
  return null;
}
